export default __webpack_public_path__ + "static/media/fb-colored-icon.0aaf16f0.svg";